// extracted by mini-css-extract-plugin
export default {"summaryHead":"subscription_summaryHead__8VDqg","summaryRow":"subscription_summaryRow__cEsOL","summaryTotal":"subscription_summaryTotal__qznGh"};